module.exports = __webpack_public_path__ + "static/media/new-icon-rating.fa4e06e7.svg";